import maintainRequest from "@/maintain/utils/maintainRequest";

export default function delGroup(groupId) {
  return maintainRequest({
    url: `/device/maintenanceMan/device_group/delGroup/${groupId}`,
    method: "post",
  });
}
